import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { AppDispatch, Store } from './index'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<Store> = useSelector
